export enum EAudioEvents {
    INIT = 'audio:init',
    PRELOAD = 'audio:preload',
    PLAY_STARTED = 'audio:play:started',
    PAUSE = 'audio:pause',
    META_LOADED = 'audio:meta:loaded',
}
